import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  createFonctionApi,
  deleteFonctionApi,
  fetchFonctions,
  updateFonctionApi,
} from "../services/fonctionsService";

const FONCTIONS_QUERY_KEY = ["fonctions"];

export const useFonctions = () =>
  useQuery({
    queryKey: FONCTIONS_QUERY_KEY,
    queryFn: fetchFonctions,
  });

export const useCreateFonction = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createFonctionApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FONCTIONS_QUERY_KEY });
      toast.success("Fonction bien ajoutée", { autoClose: 3000 });
    },
    onError: (err) => {
      const msg = err?.message || "Fonction non ajoutée";
      toast.error(msg, { autoClose: 3000 });
    },
  });
};

export const useUpdateFonction = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }) => updateFonctionApi(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FONCTIONS_QUERY_KEY });
      toast.success("Fonction bien modifiée", { autoClose: 3000 });
    },
    onError: (err) => {
      const msg = err?.message || "Fonction non modifiée";
      toast.error(msg, { autoClose: 3000 });
    },
  });
};

export const useDeleteFonction = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => deleteFonctionApi(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FONCTIONS_QUERY_KEY });
      toast.success("Fonction supprimée avec succès", { autoClose: 3000 });
    },
    onError: (err) => {
      const msg =
        err?.message ||
        "Une erreur est survenue lors de la suppression de la fonction";
      toast.error(msg, { autoClose: 3000 });
    },
  });
};
